module.exports = __webpack_public_path__ + "static/logowhite-685c305781b5c4a589f03e1fa9da15a9.png";